<main>
  <div class="container-fluid">
    <h1 class="mt-4">Dashboard</h1>
    <ol class="breadcrumb mb-4">
      <li class="breadcrumb-item active">Dashboard</li>
    </ol>
    <div class="col-12">
      <div>
        <div class="row">
          <div class="col-3 row-eq-height">
            <input class="form-control form-control-sm" [owlDateTimeTrigger]="startDate"
                   [owlDateTime]="startDate" [(ngModel)]="query.startDate"
                   placeholder="Start Date" />
            <owl-date-time [pickerType]="'calendar'" #startDate></owl-date-time>
          </div>

          <div class="col-3 row-eq-height">
            <input class="form-control form-control-sm" [owlDateTimeTrigger]="endDate"
                   [owlDateTime]="endDate" [(ngModel)]="query.endDate"
                   placeholder="End Date" />
            <owl-date-time [pickerType]="'calendar'" #endDate></owl-date-time>
          </div>

          <div class="col-3">
            <button class="btn btn-primary" (click)="genReports()">Tạo báo cáo</button>
          </div>
        </div>
      </div>



      <div class="row">
        <div class="col-12 mt-4">
          <app-merchant-networth [query]="query"
                                 [genReportEvent]="genReportEvent">
          </app-merchant-networth> 
        </div>
      </div>
    </div>
  </div>
</main>
